var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper full-height"},[(!_vm.isHideHeader)?_c('TheHeader'):_vm._e(),_c('main',{ref:"main",staticClass:"content"},[_c('div',{staticClass:"content-wrapper"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }